<template>
  <v-toolbar class="rb-dialog-toolbar" color="surface" density="compact" flat>
    <v-tabs
      v-if="tabs.length"
      v-model="internalTab"
      color="primary"
      density="compact"
      show-arrows
      hide-slider
      class="admin-tabs"
    >
      <v-tab
        v-for="item in tabs"
        :key="item.value"
        :value="item.value"
        class="custom-tab"
        :ripple="false"
      >
        <v-icon v-if="item.icon" :icon="item.icon" size="18" class="mr-2" />

        <span>{{ item.label }}</span>

        <v-chip
          v-if="item.count !== undefined"
          size="x-small"
          variant="flat"
          class="tab-count ml-2"
        >
          {{ item.count }}
        </v-chip>
      </v-tab>
    </v-tabs>
  </v-toolbar>
</template>

<script>
export default {
  name: "RbDialogToolbar",

  emits: ["update:modelValue"],

  props: {
    title: {
      type: String,
      required: true,
    },

    tabs: {
      type: Array,
      default: () => [],
    },

    modelValue: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    internalTab: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>

<style scoped>
.rb-dialog-toolbar {
  position: sticky !important;
  top: 0 !important;
  z-index: 100 !important;
  width: 100%;
  flex-shrink: 0;
  background: rgb(var(--v-theme-surface)) !important;
  border-bottom: 1px solid rgb(var(--v-theme-rb-border));
}

.admin-tabs {
  width: 100%;
}

.custom-tab {
  min-width: auto !important;
  height: 48px !important;
  padding: 0 18px !important;
  margin: 0 !important;
  border-radius: 0 !important;
  color: rgb(var(--v-theme-rb-muted)) !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.custom-tab:hover {
  background: rgb(var(--v-theme-rb-sidebar-hover)) !important;
  color: rgb(var(--v-theme-rb-text)) !important;
}

.custom-tab.v-tab--selected {
  background: rgb(var(--v-theme-rb-primary-light)) !important;
  color: rgb(var(--v-theme-rb-text)) !important;
  font-weight: 700 !important;
}

.custom-tab.v-tab--selected::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #ffb000;
}

.tab-count {
  height: 20px !important;
  min-width: 22px;
  padding: 0 6px !important;
  background: rgb(var(--v-theme-surface-variant)) !important;
  color: rgb(var(--v-theme-rb-muted)) !important;
  font-size: 10px !important;
  font-weight: 700 !important;
}

.custom-tab.v-tab--selected .tab-count {
  background: #ffb000 !important;
  color: #000000 !important;
}

.custom-tab :deep(.v-btn__overlay) {
  opacity: 0 !important;
}

:deep(.v-toolbar__content) {
  height: 48px !important;
  padding: 0 !important;
}

:deep(.v-tabs__content) {
  height: 48px !important;
}

:deep(.v-tab__slider) {
  display: none !important;
}

@media (max-width: 600px) {
  .custom-tab {
    padding: 0 12px !important;
    font-size: 11px !important;
  }
}
</style>
